import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DataService {

  constructor(private http: HttpClient) {
  }
  getMemberCourses() {
    return this.http.get("/api/model/memberCourses");
  }
}
